module.exports = __webpack_public_path__ + "resources/img/img_appen_data2_m_en.f203d54ba0fe8c5c4fb1b4500fef45a0.png";